import React, { useContext, memo } from 'react'
import PropTypes from 'prop-types'
import { GenericModal } from './../components'
import { AppContext } from './../providers'

const BeeModals = () => {
  const { modalAPI } = useContext(AppContext)
  const { queue } = modalAPI
  const modals = queue?.map((modal, index) => <GenericModal key={index} {...modal} onClose={() => modal.close()} />)
  return <>{modals}</>
}

BeeModals.propTypes = {
  queue: PropTypes.instanceOf(Object),
}

BeeModals.defaultProps = {
  queue: []
}

export default memo(BeeModals)
